
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Slide } from '@mui/material';
import Button from '@mui/material/Button';
import Alert from './Alert';



interface SnackbarMessageProps {
    open: boolean;
    message: string;
    severity: 'success' | 'info' | 'warning' | 'error';
    onClose: () => void;
}

const SnackbarMessage: React.FC<SnackbarMessageProps> = ({
    open,
    message,
    severity,
    onClose,
}) => (
    <Snackbar
        key={message} // Ensure each Snackbar has a unique key
        open={open}
        autoHideDuration={2000}
        onClose={onClose}
        TransitionComponent={(props) => <Slide {...props} direction="left" timeout={{ enter: 300, exit: 300 }} />}
        action={
            <Button color="inherit" onClick={onClose}>
                Close
            </Button>
        }
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
        <Alert onClose={onClose} severity={severity}>
            {message}
        </Alert>
    </Snackbar>
);

export default SnackbarMessage;
